import { shallowRef } from "vue";
import type { NxRowOpenTile } from "@blpde/nx-ui";

/**
 * The tiles a record list here can open into (I-3641): in a tile the page sends
 * them, on the page they are the active workspace's. The row menu shows them.
 */
export const rowOpenTiles = shallowRef<readonly NxRowOpenTile[]>([]);
